<script setup lang="ts">import {
  ArrowRight,
  PhoneCall,
  Check,
  ChevronRight,
  Clock3,
  MapPin,
  Phone,
  ShieldCheck,
  Sparkles,
  Stethoscope
} from 'lucide-vue-next'</script>
<template>
  <div>
    <section class="hero">
      <div class="container hero-grid">
        <div class="hero-copy"><span class="eyebrow">Ihre Zahnarztpraxis in Musterstadt</span>
          <h1>Gesunde Zähne.<br><em>Ein gutes Gefühl.</em></h1>
          <p>Moderne Zahnmedizin mit Erfahrung, Sorgfalt und einem offenen Ohr – für Ihre langfristige Mundgesundheit
            und ein natürlich schönes Lächeln.</p>
          <div class="hero-actions">
              <PhoneCall/>
              030 12345670

            <router-link to="/leistungen" class="text-link">Leistungen entdecken
              <ArrowRight/>
            </router-link>
          </div>
          <div class="trust-row"><span><Check/> Persönliche Betreuung</span><span><Check/> Moderne Methoden</span><span><Check/> Zentrale Lage</span>
          </div>
        </div>
        <div class="hero-visual">
          <div class="visual-card"><strong>Für Sie da</strong><small>Kompetent. Persönlich. Nah.</small></div>
          <div class="tooth-art" aria-hidden="true">
            <svg viewBox="0 0 300 360" role="img">
              <defs>
                <linearGradient id="toothFill" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stop-color="#ffffff"/>
                  <stop offset="0.58" stop-color="#f2fbff"/>
                  <stop offset="1" stop-color="#d9edf7"/>
                </linearGradient>
                <linearGradient id="toothEdge" x1="0" y1="0" x2="0" y2="1">
                  <stop stop-color="#ffffff" stop-opacity=".9"/>
                  <stop offset="1" stop-color="#b9dce9" stop-opacity=".55"/>
                </linearGradient>
                <filter id="toothShadow" x="-30%" y="-20%" width="160%" height="170%">
                  <feDropShadow dx="0" dy="22" stdDeviation="18" flood-color="#0b426a" flood-opacity=".24"/>
                </filter>
              </defs>
              <path class="tooth-shape" filter="url(#toothShadow)" d="M63 45C82 21 113 24 150 42c37-18 68-21 87 3 25 31 12 83-4 119-12 28-17 58-22 93-8 58-20 86-40 86-23 0-9-87-21-87s2 87-21 87c-20 0-32-28-40-86-5-35-10-65-22-93C51 128 38 76 63 45Z"/>
              <path class="tooth-highlight" d="M78 62c16-18 38-14 61-4-34 13-47 42-46 76-14-28-26-54-15-72Z"/>
              <path class="tooth-groove" d="M119 61c20 10 42 10 62 0"/>
              <path class="tooth-root-line" d="M150 255c-5-32-4-57 2-75"/>
              <circle cx="222" cy="73" r="7" fill="#ffffff" opacity=".88"/>
              <path d="M222 56v34M205 73h34" stroke="#fff" stroke-width="3" stroke-linecap="round" opacity=".7"/>
            </svg>
          </div>
          <div class="address-chip">
            <MapPin/>
            <span><strong>Parkallee 12</strong><small>12345 Musterstadt</small></span></div>
        </div>
      </div>
    </section>
    <section class="quick-info">
      <div class="container quick-grid">
        <div>
          <Phone/>
          <span><small>Terminvereinbarung</small><strong>030 12345670</strong></span></div>
        <div>
          <Clock3/>
          <span><small>Öffnungszeiten</small><strong>Mo–Do 8–18 Uhr</strong></span></div>
        <div>
          <MapPin/>
          <span><small>Mitten in Musterstadt</small><strong>Parkallee 12</strong></span></div>
        <router-link to="/kontakt">Alle Kontaktdaten
          <ChevronRight/>
        </router-link>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="section-heading">
          <div><span class="eyebrow">Zahnmedizin mit Weitblick</span>
            <h2>Gesundheit beginnt<br>mit Vertrauen.</h2></div>
          <p>Wir verbinden langjährige Erfahrung mit modernen Behandlungskonzepten. Dabei nehmen wir uns Zeit, erklären
            verständlich und entwickeln gemeinsam die passende Lösung.</p></div>
        <div class="home-features">
          <router-link to="/leistungen">
            <ShieldCheck/>
            <h3>Vorsorge & Erhalt</h3>
            <p>Damit Ihre eigenen Zähne möglichst lange gesund bleiben.</p><span>Zu den Leistungen <ArrowRight/></span>
          </router-link>
          <router-link to="/leistungen">
            <Sparkles/>
            <h3>Ästhetik & Zahnersatz</h3>
            <p>Natürlich schöne und funktionell überzeugende Ergebnisse.</p><span>Mehr erfahren <ArrowRight/></span>
          </router-link>
          <router-link to="/praxis">
            <Stethoscope/>
            <h3>Persönlich behandelt</h3>
            <p>Fachlich fundiert und menschlich gut aufgehoben.</p><span>Unsere Praxis <ArrowRight/></span>
          </router-link>
        </div>
      </div>
    </section>
    <section class="home-cta">
      <div class="container">
        <div><span class="eyebrow light">Willkommen am Stadtpark</span>
          <h2>Wir freuen uns auf Ihren Besuch.</h2></div>
      </div>
    </section>
  </div>
</template>
